// 配置路由相关的信息
import VueRouter from 'vue-router'
import Vue from 'vue'
 
import index from '@/views/wap/home'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
 
Vue.use(VueRouter)
const routes = [
	{
	    path: '/',
	    name: 'index',
	    component: index,
	    meta: {
	        title: '蓝牛仔 | 蓝牛仔影像 | 中国广告素材 | 中国广告图库'
	    }
	},
	{
	    path: '/search',
	    name: 'search',
	    component: (resolve) => require(['@/views/search/search.vue'], resolve),
	    meta: {
	        title: '蓝牛仔|蓝牛仔影像,中国 广告素材'
	    }
	},
	{
	    path: '/detailpage',
	    name: 'detailpage',
	    component: (resolve) => require(['@/views/container/detailPage.vue'], resolve),
	},
	 {
	    path: '/detailVid',
	    name: 'detailVid',
	    component: (resolve) => require(['@/views/container/detailVid.vue'], resolve),
	},
	{
	    path: '/favor',
	    name: 'favor',
	    component: (resolve) => require(['@/views/search/favor.vue'], resolve),
	    meta: {
	        title: '临时收藏夹'
	    }
	},
	{
	    path: '/similar',
	    name: 'similar',
	    component: (resolve) => require(['@/views/search/similar.vue'], resolve),
	    meta: {
	        title: '相似图片'
	    }
	},
	{
	    path: '/special',
	    name: 'special',
	    component: (resolve) => require(['@/views/search/special.vue'], resolve),
	    meta: {
	        title: '专题'
	    }
	},
	{
	    path: '/browse',
	    name: 'browse',
	    component: (resolve) => require(['@/views/search/browse.vue'], resolve),
	    meta: {
	        title: '最近浏览'
	    }
	},
	{
	    path: '/recommend',
	    name: 'recommend',
	    component: (resolve) => require(['@/views/container/recommend.vue'], resolve),
	    meta: {
	        title: '编辑推荐'
	    }
	},
	{
	    path: '/classify',
	    name: 'classify',
	    component: (resolve) => require(['@/views/container/classify.vue'], resolve),
	    meta: {
	        title: '分类搜索'
	    }
	},
	{
	    path: '/recharge',
	    name: 'recharge',
	    component: (resolve) => require(['@/views/order/recharge.vue'], resolve),
	    meta: {
	        title: '充值'
	    }
	},
	{
	    path: '/order',
	    name: 'order',
	    component: (resolve) => require(['@/views/order/order.vue'], resolve),
	    meta: {
	        title: '订单'
	    }
	},
	{
	    path: '/shopcart',
	    name: 'shopcart',
	    component: (resolve) => require(['@/views/order/shopcart.vue'], resolve),
	    meta: {
	        title: '购物车'
	    }
	},
	{
	    path: '/account',
	    name: 'account',
	    component: (resolve) => require(['@/views/container/account.vue'], resolve),
	    meta: {
	      title: '我的账户'
	  }
	},
	{
	  path: '/favorite',
	  name: 'favorite',
	  component: (resolve) => require(['@/views/container/favorite.vue'], resolve),
	  meta: {
	    title: '收藏夹'
	 }
	},
	
	//临时编辑收藏
	{
	    path: '/editFav',
	    name: 'editFav',
	    component: (resolve) => require(['@/views/container/editFav.vue'], resolve),
	    meta: {
	      title: '编辑收藏夹'
	   }
	  },
	  {
	    path: '/modFav',
	    name: 'modFav',
	    component: (resolve) => require(['@/views/container/modFav.vue'], resolve),
	    meta: {
	      title: '编辑收藏夹'
	   }
	  },
	  {
	    path: '/editAcco',
	    name: 'editAcco',
	    component: (resolve) => require(['@/views/container/editAcco.vue'], resolve),
	    meta: {
	      title: '编辑我的用户'
	   }
	  },
	  {
	    path: '/sample',
	    name: 'sample',
	    component: (resolve) => require(['@/views/container/sample.vue'], resolve),
	    meta: {
	      title: '小样图'
	   }
	  },
	  {
	    path: '/download',
	    name: 'download',
	    component: (resolve) => require(['@/views/order/download.vue'], resolve),
	    meta: {
	      title: '下载'
	   }
	  },
	  {
	    path: '/message',
	    name: 'message',
	    component: (resolve) => require(['@/views/container/message.vue'], resolve),
	    meta: {
	      title: '客服消息通知'
	   }
	  }, 
	
]

const router = new VueRouter({
	// 配置路由和组件之间的应用关系
	routes,
	mode: 'hash',
	linkActiveClass: 'active'
})

 router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title
	}
	next()
 })
 
// 3.将router对象传入到Vue实例
export default router
